import { toRelativeUrl } from '@okta/okta-auth-js';
import { FC, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { LoaderLogin } from '@base-app';
import { useAuth } from '@modules/auth/hooks';
import { Footer, UserSettings } from '@modules/core/components';
import { useQueryCurrentUser } from '@modules/core/hooks';
import Permissions from '@modules/permissions/components/Permissions/Permissions';
import { ErrorBoundary } from '@myhelix/dd-error-tracking';
import ErrorScreen from '@modules/core/views/ErrorScreen';

const RequiredAuth: FC = () => {
  const { isAuthenticated, authService } = useAuth();

  const { data: currentUser } = useQueryCurrentUser();

  useEffect(() => {
    const authenticate = async (): Promise<void> => {
      if (isAuthenticated === false) {
        const originalUri = toRelativeUrl(window.location.href, window.location.origin);
        authService.setOriginalUri(originalUri);
        await authService.signInWithRedirect();
      }
    };

    try {
      void authenticate();
    } catch (error) {}
  }, [isAuthenticated]);

  return currentUser ? (
    <>
      <ErrorBoundary fallback={ErrorScreen}>
        <Permissions>
          <UserSettings>
            <Outlet />
            <Footer />
          </UserSettings>
        </Permissions>
      </ErrorBoundary>
    </>
  ) : (
    <LoaderLogin />
  );
};

export default RequiredAuth;
